import React, { useEffect, useState } from "react";
import "./search.popup.css";
import { useAppDispatch } from "../../../store/hooks/store.hooks";
import { getTSlots } from "../../../store/models/slots/slot.thunk";
import { IStoreSlot } from "../../../store/models/slots/typing/slot.interface";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { slotsAttributeHelper } from "../../../utils/slotsAttributeHelper";

interface ISearchPopupProps {
  gameName: string;
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SearchPopup = ({
  gameName,
  active,
  setActive,
}: ISearchPopupProps) => {
  const [games, setGames] = useState<IStoreSlot[]>([]);
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    async function fetch() {
      const attribute = slotsAttributeHelper({
        page: 1,
        perPage: 5,
        provider: undefined,
        name: gameName,
      });
      const slotsResponse = await dispatch(
        getTSlots({
          page: 1,
          perPage: 5,
          provider: undefined,
          name: gameName,
          attribute,
        })
      );
      if (slotsResponse.type === "gettSlots/fulfilled") {
        setGames(
          (
            slotsResponse.payload as {
              games: IStoreSlot[];
              count: Number;
            }
          ).games
        );
      }
    }
    if (gameName) {
      setTimeout(() => {
        fetch();
      }, 700);
    } else {
      setGames([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameName]);
  const getPosition = () => {
    const input = document.getElementById("slots-search");
    const container = document.getElementsByClassName("root__container")[0];
    if (input) {
      const rect = input.getBoundingClientRect();
      const windowHeight = window.innerHeight; // Висота вікна браузера
      const spaceBelow = windowHeight - rect.bottom; // Простір під кнопкою
      const showAbove = spaceBelow < 328 + 80;

      if (showAbove && gameName) {
        window.scrollTo(0, window.scrollY + +rect.top.toFixed(0) - 56);
        container.scrollTo(0, container.scrollTop + +rect.top.toFixed(0) - 96);
      }
      return { top: rect.height + 12, left: 0 };
    }
    return { top: 48, left: 0 };
  };
  const position = getPosition();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const input = document.getElementById("slots-search");
      const isClickOutside = input && !input.contains(event.target as Node);
      if (isClickOutside) {
        setActive(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <Box
      className={active ? "search-popup active" : "search-popup"}
      sx={{ top: `${position.top}px`, left: `${position.left}px` }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box className="search-popup__container">
        {games.map((game) => {
          return (
            <Box className="search-popup__item" key={game.id}>
              <img
                src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/slots/300/${game.image_url}`}
                alt={game.title}
              />
              <Box className="search-popup__item-title">{game.title}</Box>
              <button
                className="search-popup__item-button pulse-button"
                onClick={() => {
                  navigator(`/slots/${game.id}`);
                }}
              >
                {t("buttons.play")}
              </button>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
